import firebase from 'firebase/compat/app';
import {
  projectGroupCollection,
  projectsCollection,
  timesheetCollectionNew,
  usersCollection,
} from './firebase';

export const fetchProjects = async () => {
  const snapshot = await projectsCollection.get();
  return snapshot?.docs?.map((doc) => ({
    ...doc.data(),
    id: doc.id,
  }));
};

export const fetchOnlyProjects = async () => {
  const snapshot = await projectsCollection
    .where('isGrouped', '==', false) // Only fetch projects that are not grouped
    .get();
  return snapshot?.docs?.map((doc) => ({
    ...doc.data(),
    id: doc.id,
    firestoreId: doc.id,
  }));
};

export const fetchProject = async (id) => {
  const projectRef = projectsCollection.doc(id);
  const doc = await projectRef.get();

  return doc.data();
};

export const fetchProjectGroupComplete = async (groupId) => {
  const projectRef = projectGroupCollection.doc(groupId);
  const doc = await projectRef.get();
  const data = doc.data();

  // Fetch linked projects if needed or assume they are stored in the data
  return {
    ...data,
    linkedProjectPlans: data.projects || [], // Assuming `projects` holds linked project data
  };
};

export const getTime = async () => {
  try {
    const usersSnapshot = await usersCollection.get();
    const usersMap = usersSnapshot.docs.reduce((acc, doc) => {
      const userData = doc.data();
      acc[doc.id.toLowerCase()] = {
        rate: parseFloat(userData.rate) || 0,
        role: userData.role || 'Unknown Role',
        cost: parseFloat(userData.cost) || 0,
      };
      return acc;
    }, {});

    const snapshotNew = await timesheetCollectionNew.get();

    const returnNewData = await Promise.all(
      snapshotNew.docs.map(async (userDoc) => {
        const timesheetData = userDoc.data();
        const userId = userDoc.id.toLowerCase();

        // Attach rate and role from the user data
        const { rate, role, cost } = usersMap[userId] || { rate: 0, role: 'Unknown Role' };
        const weeksSnapshot = await timesheetCollectionNew
          .doc(userDoc.id)
          .collection('weeks')
          .get();
        const weeks = weeksSnapshot.docs.map((weekDoc) => ({
          id: weekDoc.id,
          ...weekDoc.data(),
        }));
        const data = {
          ...timesheetData,
          id: userDoc.id,
          firestoreId: userDoc.id,
          weeks,
          rate,
          role,
          cost,
        };
        return data;
      }),
    );

    const updatedreturnNewData = returnNewData.map((ts) => {
      const updatedWeeklyHours = ts.weeks.reduce((acc, week) => {
        acc[week.id] = week.entries;
        return acc;
      }, {});
      return {
        ...ts,
        weeklyHours: updatedWeeklyHours,
      };
    });

    return updatedreturnNewData;
  } catch (err) {
    console.error('Error fetching timesheet data:', err);
    return [];
  }
};

export const updateProjectData = (id, updatedProjectData) => {
  return projectsCollection.doc(id).update(updatedProjectData);
};

export const fetchAllWeeklyHoursForProject = async (id) => {
  const data = await getTime();

  const array = [];

  data?.map((user) => {
    const weeklyHours = user?.weeklyHours;

    const list = Object?.keys(weeklyHours) || [];
    list.map((date) => {
      const projList = weeklyHours[date];

      projList?.map((proj) => {
        if (proj?.flowId == id) array.push({ ...proj });
      });
    });
  });

  return array;
};
